import React from 'react'

function EntRes() {
    return (
        <>
            <head>
                <title>خدمة المحاسبة</title>
                <meta name="description" content="
                يستهدف هذا المنتج رواد الأعمال والمبتكرين الراغبين بالعمل
                على تطوير القطاعات المختلفة في السعودية." />
            </head>
            <div style={{
                padding: '50px',
                fontSize: '15px',
                lineHeight: '1.6',
                textAlign: 'right',
                direction: 'rtl'
            }}>
                <p style={{ marginBottom: '20px' }}>
                    يستهدف هذا المنتج رواد الأعمال والمبتكرين الراغبين بالعمل
                    على تطوير القطاعات المختلفة في السعودية.
                </p>

                <p style={{ marginBottom: '20px' }}>
                    حيث تحرز السعودية تقدماً في مراتب مؤشرات التنافسية
                    العالمية، وحماية صغار المستثمرين، وتسعى لأن تكون الوجهة
                    المثالية لرواد الأعمال وأصحاب المنشآت الصغيرة والمتوسطة.
                    ويعمل المنتج على دعم استقرار رواد الأعمال وتوفير بيئة حاضنة
                    ملهمة لهم.
                </p>

                <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        fontSize: '16px'
                    }}>
                        المزايا العامة:
                    </h3>
                    <ul style={{
                        listStyleType: 'disc',
                        paddingRight: '20px',
                        margin: 0
                    }}>
                        <li style={{ marginBottom: '8px' }}>الإقامة في السعودية مع الأسرة، والتي تشمل الوالدين والأزواج والأبناء الذين تقل أعمارهم عن 25 عامًا.</li>
                        <li style={{ marginBottom: '8px' }}>الانتقال من منشأة إلى أخرى بحرية.</li>
                        <li style={{ marginBottom: '8px' }}>الإعفاء من المقابل المالي المقرر على الوافدين والمرافقين.</li>
                        <li style={{ marginBottom: '8px' }}>خروج حامل الإقامة المميزة وأفراد أسرته من السعودية والعودة إليها دون اشتراط تأشيرة.</li>
                        <li style={{ marginBottom: '8px' }}>إصدار تأشيرات زيارة للأقارب.</li>
                        <li style={{ marginBottom: '8px' }}>استخدام المسارات المُخصصة للمواطنين ومواطني دول مجلس التعاون في المنافذ.</li>
                        <li style={{ marginBottom: '8px' }}>العمل في منشآت القطاع الخاص والانتقال بينها للزوج والزوجة والأبناء.</li>
                        <li style={{ marginBottom: '8px' }}>مزاولة الأعمال التجارية وفقًا لنظام الاستثمار.</li>
                        <li>تملُّك العقارات والانتفاع بها.</li>
                    </ul>
                </div>

                <div>
                    <h3 style={{
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        fontSize: '16px'
                    }}>
                        المزايا الخاصة:
                    </h3>
                    <ul style={{
                        listStyleType: 'disc',
                        paddingRight: '20px',
                        margin: 0
                    }}>
                        <li style={{ marginBottom: '8px' }}>ترشيح شخصين من فريق العمل للحصول على إقامة الكفاءة الاستثنائية والإعفاء من معاييرها (على سبيل المثال: التنفيذيين).</li>
                        <li style={{ marginBottom: '8px' }}>إعفاء المنشأة من نطاقات لأول 3 سنوات تشغيلية.</li>
                        <li>للفئة الثانية: الحصول مباشرةً على الإقامة المميزة الدائمة.</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default EntRes